export const SEARCH_DOCUMENT_LIST = "SEARCH_DOCUMENT_LIST"
export const SEARCH_DOCUMENT_LIST_SUCCESS = "SEARCH_DOCUMENT_LIST_SUCCESS"
export const API_ERROR_SEARCH_DOCUMENT = "API_ERROR_SEARCH_DOCUMENT"

export const SEARCH_FORM_LIST = "SEARCH_FORM_LIST"
export const SEARCH_FORM_LIST_SUCCESS = "SEARCH_FORM_LIST_SUCCESS"
export const API_ERROR_SEARCH_FORM = "API_ERROR_SEARCH_FORM"

export const RECENT = "RECENT"
export const RECENT_SUCCESS = "RECENT_SUCCESS"
export const API_ERROR_RECENT = "API_ERROR_RECENT"